import { Controller } from "@hotwired/stimulus"
import tomSelect from 'tom-select'

export default class extends Controller {
  static values = {
    allowBlank: { type: Boolean, default: false },
    enableControlInput: { type: Boolean, default: false }
  }
  connect() {
    const options = {
      allowEmptyOption: this.allowBlankValue,
      create: true,
      plugins: ['input_autogrow']
    };

    if (!this.enableControlInputValue) {
      options.controlInput = null;
    }

    new tomSelect(this.element, options);
  }
}
